import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
import { createEnergyInfoApi, updateEnergyInfoApi, deleteEnergyInfoApi } from '@/api/energy';

import { mapState, mapGetters, mapActions } from 'vuex';
import clonedeep from 'lodash.clonedeep';
// import { compare } from 'fast-json-patch'

export default {
  name: 'EnergyManagement',
  data: function data() {
    return {
      tab: '新增案場',
      id: '',
      fieldName: '',
      longitude: null,
      latitude: null,
      originalData: {},
      // raw data
      currentData: {},
      // 更動的 要 call api 用
      // updateFieldName: '',
      pvSource: null,
      // [{factoryId: 'f001', factoryName: '鳳山'}]
      meterMapping: [{
        mId: 0,
        // 判斷 operations 用
        meterName: '',
        meterLocation: '',
        meterType: '電表'
      }],
      currentLastMId: 0,
      meterTypeOptions: ['電表'],
      searchInput: '',
      files: [{
        id: 'file0',
        name: '圖片 XXX',
        type: 'jpeg',
        size: 142586
      }, {
        id: 'file1',
        name: '紀錄紀錄紀錄紀錄紀錄紀錄紀錄紀錄紀錄 OOOO',
        type: 'pdf',
        size: 351744
      }, {
        id: 'file2',
        name: '文件 UU',
        type: 'xlsx',
        size: 123546
      }, {
        id: 'file3',
        name: '文件 AAa',
        type: 'xlsx',
        size: 354261
      }, {
        id: 'file4',
        name: '紀錄 CCCC',
        type: 'pdf',
        size: 123456
      }, {
        id: 'file5',
        name: '圖片 XIII',
        type: 'jpeg',
        size: 653456
      }, {
        id: 'file6',
        name: '圖片 VV',
        type: 'jpeg',
        size: 456
      }, {
        id: 'file7',
        name: '文件 PP',
        type: 'xlsx',
        size: 3516
      }, {
        id: 'file8',
        name: '紀錄 LL',
        type: 'pdf',
        size: 456987
      }, {
        id: 'file9',
        name: '圖片 XXX23456795',
        type: 'jpeg',
        size: 1234
      }, {
        id: 'file10',
        name: '紀錄 OOOO2',
        type: 'pdf',
        size: 2056
      }, {
        id: 'file11',
        name: '文件 UU2',
        type: 'xlsx',
        size: 487
      }]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState(['factoryInfo'])), mapState('projectEnergy', ['allFieldInfoData'])), mapGetters('projectEnergy', ['getFieldNameList'])), {}, {
    filteredFiles: function filteredFiles() {
      var _this = this;
      if (!this.searchInput) return this.files;
      return this.files.filter(function (file) {
        return file.name.toLowerCase().includes(_this.searchInput.toLowerCase());
      });
    },
    filesSize: function filesSize() {
      var total = this.files.reduce(function (a, b) {
        return a + b.size;
      }, 0);
      return this.formatFileSize(total);
    },
    pvSourceOptions: function pvSourceOptions() {
      return this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      }).map(function (f) {
        return {
          // TODO: 之後多選，這裡改為 object 不包 array
          value: [{
            factoryId: f.factoryId,
            factoryName: f.factory
          }],
          text: "".concat(f.factoryId, "_").concat(f.factory)
        };
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), mapActions('projectEnergy', ['getEnergyAllFieldInfoData'])), {}, {
    handleChangeTab: function handleChangeTab(tab) {
      this.resetInfo();

      // 判斷是否自動帶入 info 第一個 field, 若 infos api 尚未 call 完, 則不自動帶入
      // if (tab === '修改案場' && this.allFieldInfoData[0]?.fieldName) {
      //   this.setInfo(this.allFieldInfoData[0]?.fieldName)
      // }
    },
    handleChangeFieldName: function handleChangeFieldName(fieldName) {
      if (!fieldName) return this.resetInfo();
      this.setInfo(fieldName);
    },
    setInfo: function setInfo(fieldName) {
      var _this$allFieldInfoDat = this.allFieldInfoData.filter(function (obj) {
          return obj.fieldName === fieldName;
        }),
        _this$allFieldInfoDat2 = _slicedToArray(_this$allFieldInfoDat, 1),
        setData = _this$allFieldInfoDat2[0];
      var cloneData = clonedeep(setData);
      this.id = cloneData.id;
      this.fieldName = cloneData.fieldName;
      this.longitude = cloneData.detail.longitude;
      this.latitude = cloneData.detail.latitude;

      // pvSource 用原有的 factoryId
      this.pvSource = cloneData.pvSource;
      this.meterMapping = cloneData.meterMapping.map(function (m, mId) {
        return _objectSpread(_objectSpread({}, m), {}, {
          mId: mId
        });
      });
      this.currentLastMId = this.meterMapping.length - 1;

      // 儲存原始資料 要再 clone 一次, 避免 reference 到 cloneData
      this.originalData = {
        detail: {
          longitude: clonedeep(cloneData.detail.longitude),
          latitude: clonedeep(cloneData.detail.latitude)
        },
        pvSource: clonedeep(cloneData.pvSource),
        meterMapping: clonedeep(cloneData.meterMapping).map(function (m, mId) {
          return _objectSpread(_objectSpread({}, m), {}, {
            mId: mId
          });
        })
      };
    },
    resetInfo: function resetInfo() {
      this.id = '';
      this.fieldName = '';
      this.longitude = null;
      this.latitude = null;
      this.pvSource = null;
      this.meterMapping = [{
        meterName: '',
        meterLocation: '',
        meterType: '電表'
      }];
    },
    checkSubmitInfo: function checkSubmitInfo() {
      var _this$pvSource;
      if (!this.fieldName) {
        this.$swal('請輸入案場名稱');
        return false;
      }
      if (!((_this$pvSource = this.pvSource) !== null && _this$pvSource !== void 0 && _this$pvSource.length)) {
        this.$swal('請選擇 PV 來源');
        return false;
      }
      if (!this.longitude && this.longitude !== 0 || !this.latitude && this.latitude !== 0 || this.longitude > 180 || this.longitude < -180 || this.latitude > 90 || this.latitude < -90) {
        this.$swal('請檢查經緯度');
        return false;
      }
      var hasEmptyMeter = this.meterMapping.some(function (m) {
        return !m.meterName || !m.meterLocation;
      });
      if (this.meterMapping.length === 0 || hasEmptyMeter) {
        this.$swal('請輸入電表資訊');
        return false;
      }
      return true;
    },
    handleAddMeter: function handleAddMeter() {
      this.meterMapping.push({
        mId: this.currentLastMId + 1,
        meterName: '',
        meterLocation: '',
        meterType: '電表'
      });
      this.currentLastMId++;
    },
    handleRemoveMeter: function handleRemoveMeter(idx, mId) {
      this.meterMapping.splice(idx, 1);
    },
    handleRemoveFile: function handleRemoveFile(id) {
      this.files = this.files.filter(function (f) {
        return f.id !== id;
      });
    },
    handleChangeFiles: function handleChangeFiles(e) {
      if (!e.target.files.length) {
        console.log('remove file');
        // this.uploadFile = undefined // 上傳後又取消，清除要上傳的暫存
        // this.uploadFileName = ''
        return;
      }
      var files = e.target.files;
      console.log(files);
      // const reader = new FileReader()
      // reader.readAsArrayBuffer(file)
      // reader.onloadend = (e) => {
      //   this.uploadFile = e.target.result
      //   this.uploadFileName = file.name
      // }
      // reader.onerror = (err) => console.log(err)
    },
    formatFileSize: function formatFileSize(size) {
      if (size < 1024) return "".concat(size, " B");
      if (size < 1024 * 1024) return "".concat((size / 1024).toFixed(1), " KB");
      if (size < 1024 * 1024 * 1024) {
        return "".concat((size / (1024 * 1024)).toFixed(1), " MB");
      }
      return "".concat((size / (1024 * 1024 * 1024)).toFixed(1), " GB");
    },
    handleSubmitInfo: function handleSubmitInfo(tab) {
      // check
      // console.log(tab, this.fieldName, this.pvSource, this.meterMapping)
      var passCheck = this.checkSubmitInfo();
      // console.log(passCheck)

      if (tab === '新增案場' && passCheck) this.createEnergyInfo();
      if (tab === '修改案場' && passCheck) this.updateEnergyInfo();
    },
    handleDeleteInfo: function handleDeleteInfo() {
      var _this2 = this;
      if (!this.id || !this.fieldName) {
        return this.$swal('請先選擇要刪除的案場');
      }
      this.$swal.fire({
        title: "\u78BA\u5B9A\u522A\u9664 ".concat(this.fieldName, " ?"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true
      }).then(function (result) {
        if (result.isConfirmed) {
          _this2.deleteEnergyInfo();
        }
      });
    },
    createEnergyInfo: function createEnergyInfo() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, _res$data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.allFieldInfoData.find(function (f) {
                  return f.fieldName === _this3.fieldName;
                })) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this3.$swal.fire({
                  icon: 'warning',
                  title: '此案場名稱已被使用'
                }));
              case 2:
                params = {
                  fieldName: _this3.fieldName,
                  pvSource: _this3.pvSource,
                  meterMapping: _this3.meterMapping,
                  detail: {
                    longitude: _this3.longitude,
                    latitude: _this3.latitude
                  },
                  otherPowerSource: [],
                  files: []
                };
                _context.prev = 3;
                _context.next = 6;
                return createEnergyInfoApi(params);
              case 6:
                res = _context.sent;
                console.log(res);
                if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success) {
                  _this3.$swal.fire({
                    icon: 'success',
                    title: '創建成功'
                  });
                  _this3.resetInfo();
                  _this3.getEnergyAllFieldInfoData();
                }
                _context.next = 15;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                console.log('createEnergyInfo error', _context.t0);
                _this3.$swal.fire({
                  icon: 'error',
                  title: '創建失敗'
                });
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }))();
    },
    processingDetailOperations: function processingDetailOperations() {
      var operations = [];

      // detail 整份一起改
      // const originalDetail = this.originalData.detail
      // const currentDetail = this.detail

      // if (JSON.stringify(originalDetail) !== JSON.stringify(currentDetail)) {
      //   operations.push({
      //     op: 'replace',
      //     path: '/detail',
      //     value: currentDetail
      //   })
      // }

      var originalDetail = this.originalData.detail;
      if (originalDetail.longitude !== this.longitude) {
        // 原本沒有的話, 新增
        if (!originalDetail.longitude) {
          operations.push({
            op: 'add',
            path: '/detail/longitude',
            value: this.longitude
          });
        } else {
          operations.push({
            op: 'replace',
            path: '/detail/longitude',
            value: this.longitude
          });
        }
      }
      if (originalDetail.latitude !== this.latitude) {
        // 原本沒有的話, 新增
        if (!originalDetail.latitude) {
          operations.push({
            op: 'add',
            path: '/detail/latitude',
            value: this.latitude
          });
        } else {
          operations.push({
            op: 'replace',
            path: '/detail/latitude',
            value: this.latitude
          });
        }
      }
      return operations;
    },
    processingMeterMappingOperations: function processingMeterMappingOperations() {
      var operations = [];
      var originalMeterMapping = this.originalData.meterMapping;
      var currentMeterMapping = this.meterMapping;

      // console.log('originalMeterMapping', originalMeterMapping)
      // console.log('currentMeterMapping', currentMeterMapping)

      var replaceOps = [];
      var removeOps = [];
      var addOps = [];
      var originalByMid = new Map();
      originalMeterMapping.forEach(function (item, index) {
        originalByMid.set(item.mId, {
          item: item,
          index: index
        });
      });

      // 先處理 replace
      currentMeterMapping.forEach(function (item) {
        var cleanedItem = _objectSpread({}, item);
        delete cleanedItem.mId;
        if (originalByMid.has(item.mId)) {
          var _originalByMid$get = originalByMid.get(item.mId),
            originalItem = _originalByMid$get.item,
            originalIndex = _originalByMid$get.index;
          if (JSON.stringify(originalItem) !== JSON.stringify(item)) {
            replaceOps.push({
              op: 'replace',
              path: "/meterMapping/".concat(originalIndex),
              value: cleanedItem
            });
          }
        }
      });

      // 再處理 remove（從後面往前，避免 index shift）
      var _loop = function _loop(i) {
        var item = originalMeterMapping[i];
        var exists = currentMeterMapping.some(function (d) {
          return d.mId === item.mId;
        });
        if (!exists) {
          removeOps.push({
            op: 'remove',
            path: "/meterMapping/".concat(i)
          });
        }
      };
      for (var i = originalMeterMapping.length - 1; i >= 0; i--) {
        _loop(i);
      }

      // 處理 add（直接 append）
      currentMeterMapping.forEach(function (item) {
        var exists = originalMeterMapping.some(function (d) {
          return d.mId === item.mId;
        });
        if (!exists) {
          var cleanedItem = _objectSpread({}, item);
          delete cleanedItem.mId;
          addOps.push({
            op: 'add',
            path: "/meterMapping/-",
            value: cleanedItem
          });
        }
      });

      // 最後組合
      operations.push.apply(operations, replaceOps.concat(removeOps, addOps));
      return operations;
    },
    processingPvSourceOperations: function processingPvSourceOperations() {
      var operations = [];
      var originalPvSource = this.originalData.pvSource;
      var currentPvSource = this.pvSource;

      // console.log('originalPvSource', originalPvSource)
      // console.log('currentPvSource', currentPvSource)

      var replaceOps = [];
      var removeOps = [];
      var addOps = [];
      var originalByFactoryId = new Map();
      originalPvSource.forEach(function (item, index) {
        originalByFactoryId.set(item.factoryId, {
          item: item,
          index: index
        });
      });

      // 先處理 replace
      currentPvSource.forEach(function (item) {
        if (originalByFactoryId.has(item.factoryId)) {
          var _originalByFactoryId$ = originalByFactoryId.get(item.factoryId),
            originalItem = _originalByFactoryId$.item,
            originalIndex = _originalByFactoryId$.index;
          if (JSON.stringify(originalItem) !== JSON.stringify(item)) {
            replaceOps.push({
              op: 'replace',
              path: "/pvSource/".concat(originalIndex),
              value: item
            });
          }
        }
      });

      // 再處理 remove（從後面往前，避免 index shift）
      var _loop2 = function _loop2(i) {
        var item = originalPvSource[i];
        var exists = currentPvSource.some(function (d) {
          return d.factoryId === item.factoryId;
        });
        if (!exists) {
          removeOps.push({
            op: 'remove',
            path: "/pvSource/".concat(i)
          });
        }
      };
      for (var i = originalPvSource.length - 1; i >= 0; i--) {
        _loop2(i);
      }

      // 處理 add（直接 append）
      currentPvSource.forEach(function (item) {
        var exists = originalPvSource.some(function (d) {
          return d.factoryId === item.factoryId;
        });
        if (!exists) {
          addOps.push({
            op: 'add',
            path: "/pvSource/-",
            value: item
          });
        }
      });

      // 最後組合
      operations.push.apply(operations, replaceOps.concat(removeOps, addOps));
      return operations;
    },
    updateEnergyInfo: function updateEnergyInfo() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var operations, params, _res$data2, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // -------------------- fast-json-patch (嘗試方法 1)
                // const currentData = {
                //   pvSource: this.pvSource,
                //   meterMapping: this.meterMapping
                // }
                // // console.log('compare', this.originalData, currentData)
                // // const operations = compare(this.originalData, currentData)
                // // 取得差異
                // const rawOps = compare(this.originalData, currentData)
                // console.log('rawOps', rawOps)
                // const operations = this.compactOperations(rawOps, currentData)
                // console.log('operations', operations)
                // -------------------------------------------------------------
                // -------------------- fast-json-patch (嘗試方法 2)
                // const originalPvSource = this.originalData.pvSource
                // const currentPvSource = this.pvSource
                // const originalMeterMapping = this.originalData.meterMapping
                // const currentMeterMapping = this.meterMapping
                // console.log('originalPvSource', originalPvSource)
                // console.log('currentPvSource', currentPvSource)
                // console.log('originalMeterMapping', originalMeterMapping)
                // console.log('currentMeterMapping', currentMeterMapping)
                // // 構建更新操作
                // const operations = []
                // // <-> 先 replace 再 remove 再 add
                // // 找出 meterMapping 修改的項目
                // currentMeterMapping.forEach((item) => {
                //   const originalItem = originalMeterMapping.find(
                //     (d) => d.mId === item.mId
                //   )
                //   const cleanedItem = { ...item }
                //   delete cleanedItem.mId // 後端沒有 mId
                //   if (
                //     originalItem &&
                //     JSON.stringify(originalItem) !== JSON.stringify(item)
                //   ) {
                //     // 修改項目
                //     operations.push({
                //       op: 'replace',
                //       path: `/meterMapping/${currentMeterMapping.indexOf(item)}`,
                //       value: cleanedItem
                //     })
                //   }
                // })
                // // 找出 meterMapping 被刪除的項目
                // originalMeterMapping.forEach((item) => {
                //   if (
                //     !currentMeterMapping.some(
                //       (updatedItem) => updatedItem.mId === item.mId
                //     )
                //   ) {
                //     operations.push({
                //       op: 'remove',
                //       path: `/meterMapping/${originalMeterMapping.indexOf(item)}`
                //     })
                //   }
                // })
                // // 找出 meterMapping 新增的項目
                // currentMeterMapping.forEach((item) => {
                //   const originalItem = originalMeterMapping.find(
                //     (d) => d.mId === item.mId
                //   )
                //   const cleanedItem = { ...item }
                //   delete cleanedItem.mId // 後端沒有 mId
                //   if (!originalItem) {
                //     // 新增項目
                //     operations.push({
                //       op: 'add',
                //       path: `/meterMapping/-`,
                //       value: cleanedItem
                //     })
                //   }
                // })
                // // <-> 先 replace 再 remove 再 add
                // // 找出 pvSource 修改的項目
                // currentPvSource.forEach((item) => {
                //   const originalItem = originalPvSource.find(
                //     (d) => d.factoryId === item.factoryId
                //   )
                //   if (
                //     originalItem &&
                //     JSON.stringify(originalItem) !== JSON.stringify(item)
                //   ) {
                //     // 修改項目
                //     operations.push({
                //       op: 'replace',
                //       path: `/pvSource/${currentPvSource.indexOf(item)}`,
                //       value: item
                //     })
                //   }
                // })
                // // 找出 pvSource 被刪除的項目
                // originalPvSource.forEach((item) => {
                //   if (
                //     !currentPvSource.some(
                //       (updatedItem) => updatedItem.factoryId === item.factoryId
                //     )
                //   ) {
                //     operations.push({
                //       op: 'remove',
                //       path: `/pvSource/${originalPvSource.indexOf(item)}`
                //     })
                //   }
                // })
                // // 找出 pvSource 新增的項目
                // currentPvSource.forEach((item) => {
                //   const originalItem = originalPvSource.find(
                //     (d) => d.factoryId === item.factoryId
                //   )
                //   if (!originalItem) {
                //     // 新增項目
                //     operations.push({
                //       op: 'add',
                //       path: `/pvSource/-`,
                //       value: item
                //     })
                //   }
                // })
                // ------------------------ (嘗試方法3)
                operations = [].concat(_toConsumableArray(_this4.processingDetailOperations()), _toConsumableArray(_this4.processingMeterMappingOperations()), _toConsumableArray(_this4.processingPvSourceOperations()));
                params = {
                  id: _this4.id,
                  fieldName: _this4.fieldName,
                  operations: operations
                };
                _context2.prev = 2;
                _context2.next = 5;
                return updateEnergyInfoApi(params);
              case 5:
                res = _context2.sent;
                if (!(res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.success)) {
                  _context2.next = 11;
                  break;
                }
                _this4.$swal.fire({
                  icon: 'success',
                  title: '更新成功'
                });
                _context2.next = 10;
                return _this4.getEnergyAllFieldInfoData();
              case 10:
                _this4.setInfo(params.fieldName);
              case 11:
                _context2.next = 17;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](2);
                console.log('updateEnergyInfo error', _context2.t0);
                _this4.$swal.fire({
                  icon: 'error',
                  title: '更新失敗'
                });
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 13]]);
      }))();
    },
    deleteEnergyInfo: function deleteEnergyInfo() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var params, _res$data3, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  id: _this5.id,
                  fieldName: _this5.fieldName
                };
                _context3.prev = 1;
                _context3.next = 4;
                return deleteEnergyInfoApi(params);
              case 4:
                res = _context3.sent;
                if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.success) {
                  _this5.$swal.fire({
                    icon: 'success',
                    title: '刪除成功'
                  });
                  _this5.resetInfo();
                  _this5.getEnergyAllFieldInfoData();
                }
                _context3.next = 12;
                break;
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                console.log('deleteEnergyInfo error', _context3.t0);
                _this5.$swal.fire({
                  icon: 'error',
                  title: '刪除失敗'
                });
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }))();
    } // 分組邏輯：按陣列路徑分組
    // compactOperations (ops, current) {
    //   const grouped = {}
    //   const others = []
    //   ops.forEach((op) => {
    //     // 只處理陣列內物件（如 /meterMapping/0/xxx）
    //     const match = op.path.match(/^\/(meterMapping|pvSource)\/(\d+)\//)
    //     if (match) {
    //       const [_, key, index] = match
    //       console.log(match)
    //       console.log('_', _, key, index)
    //       const fullPath = `/${key}/${index}` // '/meterMapping/0'
    //       grouped[fullPath] = current[key][index]
    //     } else {
    //       others.push(op)
    //     }
    //   })
    //   const compacted = Object.entries(grouped).map(([path, value]) => ({
    //     op: 'replace',
    //     path,
    //     value
    //   }))
    //   return [...compacted, ...others]
    // }
  }),
  mounted: function mounted() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this6.factoryInfo.length) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return _this6.asyncInfo();
            case 3:
              if (_this6.allFieldInfoData.length) {
                _context4.next = 6;
                break;
              }
              _context4.next = 6;
              return _this6.getEnergyAllFieldInfoData();
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};